import { usePosthogEvents } from '@terminal/services/tracking/posthog/use-posthog-events/usePosthogEvents';
import { useUser } from '@terminal/stores/use-user/useUser';
import { getSafePostLoginRedirect } from '@terminal/utils/get-safe-post-login-redirect';
import { ReactNode, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';

import { appPaths } from '../../routes/app-paths';
import { queryKeys } from '../../routes/query-params';

interface AppHistoryProps {
  children: ReactNode;
}

export const AppHistory = (props: AppHistoryProps) => {
  const { user } = useUser(({ user }) => ({ user }));
  const location = useLocation();
  const navigate = useNavigate();
  const { trackDashboardOpen } = usePosthogEvents();

  useEffect(() => {
    if (user) {
      const queryParams = new URLSearchParams(location.search);
      const safeRedirect = getSafePostLoginRedirect(
        queryParams.get(queryKeys.redirect)
      );

      if (safeRedirect?.kind === 'external') {
        // External /oauth/authorize URL on a recognised identity host —
        // an already-authenticated user landed on /login?redirectTo=...
        // (rare edge case: M365 / Teams browser session reusing a logged-in
        // cookie). Hard-navigate so the identity hostname sees the cookies.
        window.location.href = safeRedirect.href;
        return;
      }

      if (safeRedirect?.kind === 'relative') {
        // In-app redirect — existing behaviour, including the dashboard
        // tracking event.
        if (safeRedirect.href === appPaths.base) {
          trackDashboardOpen('login');
        }
        navigate(safeRedirect.href, { replace: true });
        return;
      }
    }
  }, [location, user, navigate, trackDashboardOpen]);

  return <>{props.children}</>;
};
